import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';
import './FaceFrame.css';
import './HiddenFace.css';

export type HiddenFaceSize = 'card' | 'round';

export interface HiddenFaceProps {
  /** Announced in place of the face — "not revealed yet". */
  label?: string;
  /** card — giftee reveal. round — exchange hub circle. */
  size?: HiddenFaceSize;
  className?: string;
  testId?: string;
}

/** The giftee before the reveal: a face-sized disc holding a question mark. */
export function HiddenFace({ label, size = 'card', className, testId }: HiddenFaceProps) {
  return (
    <span
      className={classes('hidden-face', size !== 'card' && `hidden-face--${size}`, className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      {...testIdAttr(testId)}
    >
      <Typography as="span" role="meta/numeral" className="hidden-face__mark">
        ?
      </Typography>
    </span>
  );
}
